/**
 * @generated SignedSource<<553a77e197ff24dd7c9188ac38cc24b4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarExperienceOld_project$data = {
  readonly key: string;
  readonly projectId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FormatRules">;
  readonly " $fragmentType": "ConditionalFormattingSidebarExperienceOld_project";
};
export type ConditionalFormattingSidebarExperienceOld_project$key = {
  readonly " $data"?: ConditionalFormattingSidebarExperienceOld_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperienceOld_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarExperienceOld_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "kind": "FragmentSpread",
      "name": "FormatRules"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "1c67a6820bbe6210dc3b3345c97a2554";

export default node;
